
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/me/directive/pet/tutorial",
      function () {
        return require("private-next-pages/me/directive/pet/tutorial.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/me/directive/pet/tutorial"])
      });
    }
  